module.exports = __webpack_public_path__ + "img/text-classify8.d38617cb.png";